/*
* Useful documentation for the structure of the config files can be found via the two links below
* https://github.com/manfredsteyer/angular-oauth2-oidc#logging-in
* https://docs.abp.io/en/abp/latest/UI/Angular/Environment
* */

const baseUrl = 'http://localhost:4200';

export const environment = {
  production: true,
  validationCodeExpiryHrs: 1,
  authLoginSettings: {
    grant_type: 'password',
    scope: 'offline_access FitMed',
    client_id: 'FitMed_AngularApp',
    client_secret: '1q2w3E*'
  },
  // Add any custom env variables here
  application: {
    baseUrl: baseUrl + '/',
    name: 'PernixFitMedAngular',
    logoUrl: '',
  },
  // oAuthConfig: {
  //   issuer: 'https://api.fitmed.app/',
  //   redirectUri: baseUrl,
  //   clientId: 'FitMed_AngularApp',
  //   // responseType: 'code',
  //   scope: 'offline_access FitMed',
  //   dummyClientSecret: '1q2w3E*',
  //   showDebugInformation: true
  // },
  apis: {
    default: {
      url: 'https://api.fitmed.app/',
      rootNamespace: 'Pernix.FitMed.Web',
    },
  }
};
